// Editable homepage copy from the CMS (/api/site/homepage), with the current
// copy as a graceful default so the homepage always renders.
import { useState, useEffect } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HOME_DEFAULTS = {
  heroEyebrow: "State, Working as one",
  heroHeading: "Strategy, built\nto be **executed.**",
  heroSubhead: "Growth gets lost between strategies, functions and priorities. We find what is holding it back, build strategy around execution, and stay to make it happen.",
  heroCta1: "Bring Us Your Growth Problem",
  heroCta2: "Find Your Switch",
  problemEyebrow: "The problem",
  problemHeading: "Everyone is working.\nGrowth **isn't.**",
  problemIntro: "Most businesses do not lack activity, capability or intent. Growth gets lost when every function solves a different version of the problem. Marketing chases demand, sales chases the quarter, technology chases systems, and leadership tries to move it all forward, apart.",
  modelEyebrow: "The SWITCH model",
  modelHeading: "Strategy built\nto be **executed.**",
  modelIntro: "The problem is not the absence of strategy. It is that most strategies are built apart from the realities of execution. We bring the two together from the first move, and stay until growth is set in motion.",
  workEyebrow: "Selected work",
  workHeading: "**Proof**, not promises.",
  workIntro: "The pattern stays the same: a growth problem, set in motion, and the outcome it produced.",
  insightsEyebrow: "Most read on the Switchboard",
  insightsHeading: "Thinking worth **your time.**",
  closingEyebrow: "Start the conversation",
  closingHeading: "Tell us what is\nnot moving.\n**We'll flip the switch.**",
  closingSubhead: "Not another deck. A system that moves, strategy built around execution, and a team that stays to make it happen.",
  closingCta1: "Bring Us Your Growth Problem",
  closingCta2: "Find Your Switch",
};

let _cache = null;
let _promise = null;

export const invalidateHomeCopy = () => { _cache = null; _promise = null; };

export const loadHomeCopy = () => {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = fetch(`${API}/site/homepage`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then((d) => { _cache = { ...HOME_DEFAULTS, ...d }; return _cache; })
      .catch(() => { _cache = HOME_DEFAULTS; return HOME_DEFAULTS; });
  }
  return _promise;
};

export const useHomeCopy = () => {
  const [copy, setCopy] = useState(_cache || HOME_DEFAULTS);
  useEffect(() => {
    let alive = true;
    loadHomeCopy().then((c) => alive && setCopy(c));
    return () => { alive = false; };
  }, []);
  return copy;
};
